/**
 * Notify Me helpers.
 *
 * Klaviyo renders the back-in-stock button for sold-out variants. Keep Shopify's
 * dynamic checkout hidden in that state so the two calls to action do not stack.
 */
;(function () {
  "use strict"

  const PAYMENT_BUTTON_SELECTOR = ".shopify-payment-button"
  const variantAvailabilityBySection = new Map()

  function getProductForms(root = document) {
    return Array.from(root.querySelectorAll('form[data-type="add-to-cart-form"]'))
  }

  function getInstallmentForms(productForm) {
    const scope =
      productForm.closest("section") || productForm.closest("[data-section]") || document

    return Array.from(scope.querySelectorAll('form[action*="/cart/add"]')).filter(form => {
      if (form === productForm || form.dataset.type === "add-to-cart-form") return false

      return (
        form.classList.contains("installment") ||
        Boolean(form.querySelector("shopify-payment-terms"))
      )
    })
  }

  function getPaymentTerms(productForm) {
    return getInstallmentForms(productForm).flatMap(form =>
      Array.from(form.querySelectorAll("shopify-payment-terms"))
    )
  }

  function isElementVisible(element) {
    if (!element) return false

    const style = window.getComputedStyle(element)

    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      element.getClientRects().length > 0
    )
  }

  function hasVisibleNotifyMeButton(productForm) {
    return isElementVisible(productForm.querySelector("#klaviyo-bis-button-container button"))
  }

  function getSectionId(productForm) {
    const productFormId = productForm.getAttribute("id")

    if (productFormId && productFormId.startsWith("product-form-")) {
      return productFormId.replace("product-form-", "")
    }

    const section = productForm.closest("[data-section]")
    return section ? section.dataset.section : null
  }

  function getSelectedVariant(productForm) {
    const sectionId = getSectionId(productForm)
    const variantSelects =
      (sectionId && document.getElementById(`variant-selects-${sectionId}`)) ||
      productForm.closest("section")?.querySelector("variant-selects")

    return variantSelects && variantSelects.currentVariant ? variantSelects.currentVariant : null
  }

  function isSoldOut(productForm) {
    const sectionId = getSectionId(productForm)
    const selectedVariant = getSelectedVariant(productForm)

    if (hasVisibleNotifyMeButton(productForm)) return true

    if (selectedVariant && Object.prototype.hasOwnProperty.call(selectedVariant, "available")) {
      return !selectedVariant.available
    }

    if (sectionId && variantAvailabilityBySection.has(sectionId)) {
      return !variantAvailabilityBySection.get(sectionId)
    }

    const variantInput = productForm.querySelector("input.product-variant-id")
    const submitButton = productForm.querySelector('[name="add"]')

    return Boolean(
      (variantInput && variantInput.disabled) ||
      (submitButton && (submitButton.disabled || submitButton.hasAttribute("disabled")))
    )
  }

  function updatePaymentButton(productForm) {
    const paymentButton = productForm.querySelector(PAYMENT_BUTTON_SELECTOR)
    const soldOut = isSoldOut(productForm)

    if (paymentButton) {
      setHidden(paymentButton, soldOut)
    }

    getInstallmentForms(productForm).forEach(installmentForm => {
      setHidden(installmentForm, soldOut)
    })

    getPaymentTerms(productForm).forEach(paymentTerms => {
      setHidden(paymentTerms, soldOut)
    })
  }

  function setHidden(element, hidden) {
    if (element.hidden !== hidden) element.hidden = hidden

    const display = hidden ? "none" : ""
    if (element.style.display !== display) element.style.display = display
  }

  function updatePaymentButtons(root = document) {
    getProductForms(root).forEach(updatePaymentButton)
  }

  function updateAfterThemeChange(sectionId, variant) {
    if (sectionId && variant && Object.prototype.hasOwnProperty.call(variant, "available")) {
      variantAvailabilityBySection.set(sectionId, variant.available)
    }

    const section = sectionId ? document.querySelector(`[data-section="${sectionId}"]`) : document

    ;[0, 150, 450].forEach(delay => {
      window.setTimeout(() => {
        updatePaymentButtons(section || document)
      }, delay)
    })
  }

  function init() {
    updatePaymentButtons()
  }

  document.addEventListener("change", event => {
    if (
      !event.target.matches(
        "variant-selects input, variant-selects select, input.product-variant-id"
      )
    ) {
      return
    }

    const section = event.target.closest("[data-section]")
    updateAfterThemeChange(section ? section.dataset.section : null)
  })

  document.addEventListener("shopify:section:load", init)

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      updateAfterThemeChange(
        event && event.data ? event.data.sectionId : null,
        event && event.data ? event.data.variant : null
      )
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()
